import supportpal from './i18n/index.js'

export const config = {
    autoPlaceholder: 'off',
    formatOnDisplay: false,
    initialCountry: $('meta[name=default_country]').prop('content'),
    countryOrder: [$('meta[name=default_country]').prop('content')],
    separateDialCode: true,
    // Not included in SupportPal locale
    excludeCountries: ['cc', 'cx', 'gf', 'gi', 'gp', 'mq', 're', 'sj', 'tk', 'yt'],
    i18n: supportpal,
    utilsScript: laroute.asset('resources/assets/libs/intltelinput/js/utils.js'),
};
